import styled from "styled-components";

export const HiddenYouTube = styled.div`
  position: absolute;
  left: -9999px;
  top: 0;

  width: 200px;
  height: 200px;
  overflow: hidden;
`;

export const ProgressBackground = styled.div`
  position: relative;
  z-index: -1;

  width: 100%;
  height: 20px;
  background-color: ${({ theme }) => theme.gray};
  border-radius: 2px;

  margin-top: 5%;
`;

export const Progress = styled.div<{ value: number }>`
  width: ${({ value }) => value * 6.25}%;
  height: 20px;

  align-self: flex-start;

  background-color: ${({ theme }) => theme.green};

  border-radius: 2px;

  transition: width 0.5s;
`;

export const Separator = styled.div`
  position: absolute;
  top: 0;

  width: 0.8px;
  height: 100%;

  background-color: ${({ theme }) => theme.border100};
`;

export const TimeStamps = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

export const TimeStamp = styled.p`
  color: ${({ theme }) => theme.text};
`;

export const PlayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 56px;
  height: 56px;
  margin: 20px auto 0;
  padding: 0;

  background-color: transparent;
  border: none;

  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.green};
    outline-offset: 4px;
  }
`;

export const PlayerMessage = styled.p`
  width: 100%;
  margin: 12px 0 0;

  color: ${({ theme }) => theme.text};
  font-size: 0.95rem;
  font-weight: bold;
  text-align: center;
`;
